import Regia61 from '../../../../src/media/SCG/Regia/6/Regia 6.webp'
import Regia62 from '../../../../src/media/SCG/Regia/6/Regia 6 D.webp'
import Regia63 from '../../../../src/media/SCG/Regia/6/Regia 6 P.webp'

const Regia6images =[
Regia61,Regia62,Regia63
]

export default Regia6images;